import { Component, OnInit} from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-myproposal',
  templateUrl: './myproposal.component.html',
  styleUrls: ['./myproposal.component.css']
})
export class MyproposalComponent implements OnInit {
	listPro = []; token = localStorage.getItem('Sastana_Token'); modalRef: BsModalRef;
  tot : number = 1; 
  constructor(private conn: ConnectionService) { }

  ngOnInit() {
  	this.getContract();
  }

  getContract(){
    this.conn.getRequest('proposal/myProposal', this.token).subscribe((res: any) => {
      this.listPro=res.result;
      for(var j=0;j<this.listPro.length;j++){
        this.listPro[j].position=j+1;
      }
    });
  }

}

